import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Navigation from '../../blocks/navigation';
import Progress from '../../themed/progress';

import css from './dashboard.module.scss';

const Dashboard = (): JSX.Element => {
	const [scrolled, setScrolled] = useState(0);

	const location = useLocation();

	const handleScroll = (e: React.UIEvent<HTMLElement, UIEvent>) => {
		const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

		const totalHeight = scrollHeight - clientHeight;
		const progress = (scrollTop / totalHeight) * 100;

		setScrolled(progress);
	};

	useEffect(() => {
		setScrolled(0);
	}, [location.pathname]);

	return (
		<React.Fragment>
			<Progress progress={scrolled} />

			<div className={css.dashboard}>
				<Navigation />

				<main className={css['dashboard-right']} onScroll={handleScroll}>
					<Outlet />
				</main>
			</div>
		</React.Fragment>
	);
};

export default Dashboard;
